import { createI18n } from "vue-i18n";
import { en, ar } from "vuetify/locale";
import arMessages from "./ar";
import enMessages from "./en";
import { arabicPluralRules } from "./plurals";
import { numberFormats } from "./number";
import { datetimeFormats } from "./datetimes";

const messages = {
  en: {
    $vuetify: en,
    ...enMessages,
  },
  ar: {
    $vuetify: ar,
    ...arMessages,
  },
};

const i18n = createI18n({
  legacy: false, // Vuetify does not support the legacy mode of vue-i18n
  globalInjection: true,
  locale: "en",
  fallbackLocale: "en",
  messages,
  numberFormats,
  datetimeFormats,
  pluralizationRules: {
    ar: arabicPluralRules,
  },
});

export default i18n;

